module.exports = __webpack_public_path__ + "img/mortality_patient_death.03b4a3f0.svg";